import { useEffect, useRef } from "react";
import $ from 'jquery';
import { observer } from "mobx-react";
import { isUndefined } from "../../util/util";
import useIsMobile from "../../util/useIsMobile";
import constMap from "../../const/const";
import rootScope from "../../store/rootScopeStore";
const KakuninModal = observer((props) => {
    const modalDialog = useRef(null);
    let isMobile = useIsMobile();
    useEffect(() => {
        const errordialogcontailer = document.querySelector('.error-dialog-contailer');
        const navbar = document.querySelector('.navbar')
        const modalDialogEle = $(modalDialog.current);
        const topDefault = -(errordialogcontailer.offsetTop + modalDialogEle[0].offsetHeight + navbar.offsetHeight + 100);
        const top = 30;
        modalDialogEle.css({
            top: `${topDefault}px`
        });
        setTimeout(() => {
            modalDialogEle.animate({
                top: `${top}px`
            }, {
                duration: 500
            });
            modalDialogEle.css({
                display: 'block'
            });
        }, 0);
    }, []);

    const functionnamekeyDisp = (name, isMobile) => {
        const shortcut = constMap.btnShortcut[name];
        let backString = typeof shortcut === 'object' ? shortcut[rootScope.pageType] : shortcut;
        if (isUndefined(backString) || isMobile) backString = "";
        else backString = `(${backString})`;
        return name + backString;
    };
    return (
        <> <div ref={modalDialog} className="modal-box modal-dialog modal-content" style={{ display: 'none' }}>
            <form>
                <div className="error-dialog">
                    <div className="modal-header">
                        <h4 align="center">{props.option.title}</h4>
                    </div>
                    <div className="modal-body" id="modal-body" align="left">
                        {props.option.message}
                    </div>
                    <div className="modal-footer" id="modal-body" align="right">
                        {/* okDialog繝懊ち繝ｳ */}
                        {(props.option.cancelIsHide || props.okIsHide) && <button className="btn btn-primary msg-dialog-btn" type="button" onClick={props.option.confirm}>{functionnamekeyDisp(props.option.okView, isMobile)}</button>}
                        {/* confirmDialog繝懊ち繝ｳ */}
                        {!props.option.cancelIsHide && <button className="btn btn-primary msg-dialog-btn" type="button" onClick={props.option.confirm}>{functionnamekeyDisp(props.option.okView, isMobile)}</button>}
                        {!props.option.cancelIsHide && <button className="btn btn-warning msg-dialog-btn" type="button" onClick={props.option.cancel}>{functionnamekeyDisp(props.option.cancelView, isMobile)}</button>}
                    </div>
                </div>
            </form>
        </div>
        </>
    );

})
export default KakuninModal;